const CENTS_PER_DOLLAR = 100

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
})

/** Integer cents as US dollars (`123450` → `$1,234.50`), matching app-main's `formatPrice`. */
export const formatPrice = (cents: number): string => usdFormatter.format(cents / CENTS_PER_DOLLAR)
